import React, { Component } from "react";
import Form from "react-validation/build/form";
import CheckButton from "react-validation/build/button";
import { isEmail } from "validator";
import AuthService from "../../services/auth.service";
import Input from "react-validation/build/input";
import Select from "react-select";
import 'local-date/lib/polyfills/reflect';
import 'local-date/lib/polyfills/array-from';

import {
    Heading,
    FormControl,
    FormLabel,
    Button,
    InputRightElement,
    Text,
    Link,
    Stack,
    Box,
    VStack,
  } from '@chakra-ui/react'
import { ViewIcon, ViewOffIcon } from '@chakra-ui/icons';
import { LightBg, ParentCard, Card } from "./style";
import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";

const required = value => {
    if (!value) {
      return (
        <div className="alert alert-danger" role="alert" style={{height: '30px',paddingTop: '2px'}}>
          Harus diisi!
        </div>
      );
    }
};

const email = value => {
    if (!isEmail(value)) {
        return (
        <div className="alert alert-danger" role="alert" style={{height: '30px',paddingTop: '2px'}}>
            Email tidak valid!
        </div>
        );
    }
};

const vpassword = value => {
    if (value.length <= 8) {
        return (
        <div className="alert alert-danger" role="alert" style={{height: '30px',paddingTop: '2px'}}>
            Password harus lebih dari 8 karakter!
        </div>
        );
    }
};

export default class RegisterPeserta extends Component {
    constructor(props) {
        super(props);
        this.handleRegister = this.handleRegister.bind(this);
        this.onChangeUsername = this.onChangeUsername.bind(this);
        this.onChangeEmail = this.onChangeEmail.bind(this);
        this.onChangePassword = this.onChangePassword.bind(this);
        this.onChangeJenisKelamin = this.onChangeJenisKelamin.bind(this);
        this.onChangeTempatLahir = this.onChangeTempatLahir.bind(this);
        this.onChangeTanggalLahir = this.onChangeTanggalLahir.bind(this);
        this.onChangeNomorPonsel = this.onChangeNomorPonsel.bind(this);
        this.onChangeShowPassword = this.onChangeShowPassword.bind(this);
        this.state = {
          nama: "",
          emailUser: "",
          password: "",
          jenisKelamin: "",
          option: [
            { value: 0, label: "Perempuan" },
            { value: 1, label: "Laki-laki" }],
          tempatLahir: "",
          tanggalLahir: new Date(),
          nomorPonsel: "",
          showPassword: false,
          successful: false,
          message: "",
        };
    }

    onChangeUsername(e) {
        this.setState({
          nama: e.target.value
        });
    }

    onChangeEmail(e) {
        this.setState({
            emailUser: e.target.value
        });
    }

    onChangePassword(e) {
        this.setState({
            password: e.target.value
        });
    }

    onChangeJenisKelamin(e) {
        this.setState({
            jenisKelamin: e.value
        });
    }

    onChangeTempatLahir(e) {
        this.setState({
            tempatLahir: e.target.value
        });
    }

    onChangeTanggalLahir(e) {
        this.setState({
            tanggalLahir: e
        });
    }
    
    onChangeNomorPonsel(e) {
        this.setState({
            nomorPonsel: e.target.value
        });
    }

    onChangeShowPassword() {
        this.setState({
            showPassword: !this.state.showPassword
        })
    }


    handleRegister(e) {
        e.preventDefault();
        this.setState({
            message: "",
            successful: false
        });
        this.form.validateAll();
        console.log(this.checkBtn.context._errors.length)
        console.log(this.state.tanggalLahir)
        if (this.checkBtn.context._errors.length === 0) {
            AuthService.register(
            this.state.nama,
            this.state.emailUser,
            this.state.password,
            this.state.jenisKelamin,
            this.state.tempatLahir,
            this.state.tanggalLahir,
            this.state.nomorPonsel
            ).then(
                response => {
                    this.setState({
                    message: "Selamat, Anda telah berhasil register!",
                    successful: true
                    });
                },
                error => {
                    console.log(this.state.jenisKelamin)
                    console.log(error)
                    const resMessage =
                    (error.response &&
                        error.response.data &&
                        error.response.data.message) ||
                    error.message ||
                    error.toString();

                    if(resMessage.includes("could not execute statement; SQL [n/a]; constraint [UK_5fxlusj9c11kvgahypos561pv]; nested exception is org.hibernate.exception.ConstraintViolationException: could not execute statement")) {
                        this.setState({
                            message: "Maaf, email sudah terdaftar, coba email lain"
                        });
                    } else {
                        this.setState({
                            message: "Terjadi kesalahan, coba lagi"
                        });
                    }

                    this.setState({
                        successful: false,
                        message: "Terjadi kesalahan, coba lagi"
                    });
                }
            );
        }
    }

    render() {
        return (
            <>
            <LightBg>
                <ParentCard>
                    <Card>
                        <Stack>
                            <Box>
                                <Heading paddingBottom={10} textAlign={'center'} fontFamily={'Inter'}>Daftar</Heading>
                            </Box>
                            <Box>
                                <VStack spacing={4} align='stretch'>
                                    <Form
                                    onSubmit={this.handleRegister}
                                    ref={c => {
                                      this.form = c;
                                    }}
                                    >
                                    {!this.state.successful && (
                                    <div>
                                        <Box pt={4}>
                                            <FormControl isRequired fontFamily={'Inter'}>
                                                <FormLabel htmlFor='namalengkap'>Nama Lengkap</FormLabel>
                                                <Input 
                                                style={{paddingLeft: "8px", paddingTop: "6px", paddingBottom: "6px", border: '1px solid #F5F5F5', borderRadius: '5px', width: '100%', height:'40px'}} 
                                                id='nama' 
                                                placeholder='Masukkan nama lengkap'
                                                value={this.state.nama}
                                                validations={[required]}
                                                onChange={this.onChangeUsername} />
                                            </FormControl>
                                        </Box>
                                        <Box pt={4}> 
                                        <FormControl isRequired fontFamily={'Inter'}>
                                            <FormLabel htmlFor='email'>Email</FormLabel>
                                            <Input style={{paddingLeft: "8px", paddingTop: "6px", paddingBottom: "6px", border: '1px solid #F5F5F5', borderRadius: '5px', width: '100%', height:'40px'}}  
                                            id='emailUser' 
                                            placeholder='Masukkan alamat email' 
                                            value={this.state.emailUser}
                                            validations={[required,email]}
                                            onChange={this.onChangeEmail}/>
                                        </FormControl>
                                        </Box>
                                        <Box pt={4}> 
                                            <FormControl id='password' isRequired fontFamily={'Inter'}>
                                                <FormLabel htmlFor='katasandi'>Kata sandi</FormLabel>
                                                <div>
                                                    <Input style={{paddingLeft: "8px", paddingTop: "6px", paddingBottom: "6px", border: '1px solid #F5F5F5', borderRadius: '5px', width: '100%', height:'40px'}} 
                                                    placeholder='Masukkan kata sandi' 
                                                    value={this.state.password}
                                                    type={this.state.showPassword ? 'text' : 'password'}
                                                    validations={[required,vpassword]}
                                                    onChange={this.onChangePassword}/>
                                                    <InputRightElement h={'full'}>
                                                        <Button
                                                            variant={'ghost'}
                                                            onClick={this.onChangeShowPassword}
                                                        >
                                                            {this.state.showPassword ? <ViewIcon /> : <ViewOffIcon />}
                                                        </Button>
                                                    </InputRightElement>
                                                </div>
                                            </FormControl>
                                        </Box>
                                        <Box pt={4}> 
                                            <FormControl isRequired fontFamily={'Inter'}>
                                                <FormLabel htmlFor='jeniskelamin'>Jenis Kelamin</FormLabel>
                                                <Select
                                                style={{paddingLeft: "8px", paddingTop: "6px", paddingBottom: "6px", border: '1px solid #F5F5F5', borderRadius: '5px', width: '100%', height:'40px'}} 
                                                id='jeniskelamin' 
                                                options={this.state.option}
                                                onChange={this.onChangeJenisKelamin.bind(this)}
                                                value={this.state.option.find((obj) => obj.value === this.state.jenisKelamin)}
                                                placeholder="Pilih jenis kelamin" />
                                            </FormControl>
                                        </Box>
                                        <Box pt={4}> 
                                            <FormControl isRequired fontFamily={'Inter'}>
                                                <FormLabel htmlFor='tempatlahir'>Tempat Lahir</FormLabel>
                                                <Input style={{paddingLeft: "8px", paddingTop: "6px", paddingBottom: "6px", border: '1px solid #F5F5F5', borderRadius: '5px', width: '100%', height:'40px'}}  
                                                id='tempatlahir' 
                                                placeholder='Masukkan tempat lahir' 
                                                value={this.state.tempatLahir}
                                                validations={[required]}
                                                onChange={this.onChangeTempatLahir}/>
                                            </FormControl>
                                        </Box>
                                        <Box pt={4}> 
                                            <FormControl isRequired fontFamily={'Inter'}>
                                            <FormLabel htmlFor='tanggallahir'>Tanggal lahir</FormLabel>
                                            <div>
                                                <style>
                                                    {`.date-picker input {
                                                        width: 100%;
                                                        height: 40px;
                                                        padding-left: 17px;
                                                        border: 1px solid #E2E8F0;
                                                        border-radius: 5px;}
                                                    .date-picker focus {
                                                        border-color:#cd3232;
                                                    }
                                                    `}
                                                </style>
                                                <DatePicker wrapperClassName="date-picker"
                                                    dateFormat="dd/MM/yyyy" 
                                                    selected={this.state.tanggalLahir} 
                                                    onChange={this.onChangeTanggalLahir}/>
                                            </div>
                                            </FormControl>
                                        </Box>
                                        <Box pt={4}> 
                                            <FormControl isRequired fontFamily={'Inter'}>
                                            <FormLabel htmlFor='nomorPonsel'>Nomor Ponsel</FormLabel>
                                                <Input style={{paddingLeft: "8px", paddingTop: "6px", paddingBottom: "6px", border: '1px solid #F5F5F5', borderRadius: '5px', width: '100%', height:'40px'}}  
                                                id='nomorPonsel' 
                                                placeholder='Masukkan nomor ponsel' 
                                                value={this.state.nomorPonsel}
                                                validations={[required]}
                                                onChange={this.onChangeNomorPonsel}/>
                                            </FormControl>
                                        </Box>
                                        <Box fontFamily={'Inter'} align={'center'}>
                                            <Button style={{paddingTop: "6px", paddingBottom: "6px", background:'#6554C0', color:'#FFFFFF', justifyContent:'center'}} 
                                                mt={4} type='submit'>Daftar</Button>
                                        </Box>
                                    </div>
                                    )}
                                        {this.state.message && (
                                        <div className="form-group">
                                            <div
                                            className={
                                                this.state.successful
                                                ? "alert alert-success"
                                                : "alert alert-danger"
                                            }
                                            role="alert"
                                            >
                                            {this.state.message}
                                            </div>
                                        </div>
                                        )}
                                        <CheckButton
                                        style={{ display: "none" }}
                                        ref={c => {
                                            this.checkBtn = c;
                                        }}
                                        />
                                    </Form>
                                </VStack>
                            </Box>
                            <Box fontFamily={'Inter'} >
                                <Text align={'center'}>Sudah punya akun? <Link href="/login" color={'blue.400'}>Masuk</Link></Text>
                            </Box>
                        </Stack>
                    </Card>
                </ParentCard>
            </LightBg>
            </>
        );
    }
}